var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"device-monitor_map"},[_c('BMap',{ref:"bmap",on:{"loaded":_vm.bmapLoaded,"mapHandler":_vm.mapHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }